// extracted by mini-css-extract-plugin
module.exports = {"container":"KioskOrder_container__32C_t","title":"KioskOrder_title__2NmYG","emailInput":"KioskOrder_emailInput__2Tbrk","actionButton":"KioskOrder_actionButton__U3r44"};